import { useCallback } from "react";
import { useDraggable, useDroppable } from "@dnd-kit/core";
import type { ScheduleSwapTarget } from "./schedule-swap";

export function useScheduleSwapRow(
  dragId: string,
  swapData: ScheduleSwapTarget,
) {
  const draggable = useDraggable({ id: dragId, data: swapData });
  const droppable = useDroppable({ id: dragId, data: swapData });
  const setDraggableNode = draggable.setNodeRef;
  const setDroppableNode = droppable.setNodeRef;
  // Stable ref so re-renders from typing don't re-register the row.
  const setNodeRef = useCallback(
    (node: HTMLElement | null) => {
      setDraggableNode(node);
      setDroppableNode(node);
    },
    [setDraggableNode, setDroppableNode],
  );
  const transform = draggable.transform;
  const translate = transform
    ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
    : undefined;
  const style = { transform: translate };
  const isDropTarget = droppable.isOver && !draggable.isDragging;
  return {
    setNodeRef,
    style,
    isDragging: draggable.isDragging,
    isDropTarget,
    setActivatorNodeRef: draggable.setActivatorNodeRef,
    attributes: draggable.attributes,
    listeners: draggable.listeners,
  };
}

export type ScheduleSwapRow = ReturnType<typeof useScheduleSwapRow>;
